module.exports = __webpack_public_path__ + "img/back7.f49245bf.png";